/**
 * Factory method to create OAuthCallback component associated with specific OAuth callback ID
 * Component stores query parameters in localStorage using responseId as key so that the listening
 * window can access it
 * @param {string} responseId Identifier to use for OAuth callback
 * @return {{}} Vue component
 */
export default function(responseId) {
  return {
    mounted() {
      localStorage.setItem(responseId, window.location.search);
      window.close();
    }
  };
}
